import React from 'react';
export function KitContentsSection() {
  const contents = [{
    emoji: '📅',
    title: '5 Jahresbände',
    desc: '52 Wochen geplante Stunden'
  }, {
    emoji: '🌿',
    title: 'Therapeutisches Yoga',
    desc: '25 Protokolle für echte Beschwerden'
  }, {
    emoji: '🪷',
    title: 'Philosophie & Themen',
    desc: '52 Themen, um jede Stunde zu erheben'
  }, {
    emoji: '📖',
    title: 'Asana-Bibliothek',
    desc: '200+ Haltungen mit verbalen Cues'
  }, {
    emoji: '💼',
    title: 'Das Yoga-Business',
    desc: 'Vom Yoga in Deutschland leben'
  }];
  return <section className="bg-brand-cream px-4 py-20" data-id="element-94">
      <div className="mx-auto max-w-5xl" data-id="element-95">
        <h2 className="mb-16 text-center text-3xl font-black text-brand-text md:text-4xl" data-id="element-96">
          📦 Was enthält das Yoga Bereit Kit?
        </h2>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2" data-id="element-97">
          {contents.map((item, index) => <article key={item.title} className={`rounded-3xl border border-brand-creamDark bg-[#EDE5D8] p-8 text-center shadow-sm ${index === 4 ? 'md:col-span-2 md:mx-auto md:w-1/2' : ''}`} data-id="element-98">
              <div className="mb-4 text-4xl" aria-hidden="true" data-id="element-99">
                {item.emoji}
              </div>
              <h3 className="mb-2 text-xl font-bold text-brand-text" data-id="element-100">
                {item.title}
              </h3>
              <p className="text-sm text-brand-gray" data-id="element-101">{item.desc}</p>
            </article>)}
        </div>
      </div>
    </section>;
}